 

import { Block } from "@/backend/models/block";
import { useBlockStore, BlockTreeObject } from "@/frontend/store/BlockStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { DownCaret } from "@/frontend/SVGs/DownCaret";
import { RightCaret } from "@/frontend/SVGs/RightCaret";
import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import {  OverlayTrigger, Tooltip } from "react-bootstrap";
import { Container } from "@/backend/models/containers/container";
import { getParentType, getRootId } from "@/backend/lib/utils";
import { ProcedureInstanceBase } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { ImplementationFunction } from "@/backend/models/implementationFunction";

export function BlockModalItem(props: { blockId: string, parent: Container | Block | ProcedureInstanceBase | ImplementationFunction, position: number, setShow: any, error: string, isScaffold?: boolean }) {
  const { blockId, parent, position, setShow, error, isScaffold } = props;
  const createFromBlock = useTreeStore((state) => state.createFromBlock);
  const node = useBlockStore((state) => state.tree[blockId]);
  const block = node.item as Block;
  const [expanded, setExpanded] = useState(false);
  const label = expanded ? I18n.get('closeBlock', { title: block.title }) : I18n.get('expandBlock', { title: block.title });
  const font = error ? 'text-secondary' : 'fw-bold';

  const onSelectBlock = () => {
    if (error) return;

    const request = {
      block,
      targetParentId: parent.id,
      targetRootId: getRootId(parent),
      targetParentType: getParentType(parent),
      position,
      targetIsScaffold: isScaffold || (parent instanceof Container && parent.isScaffold) || false
    };

    void createFromBlock(request);
    setShow(false);
  };

  return (
    <div>
      <button type='button' aria-label={label} className='border-0 bg-transparent rounded' onClick={() => setExpanded(!expanded)}>
        { expanded ? <DownCaret /> : <RightCaret /> }
      </button>
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={error ? <Tooltip>{error}</Tooltip> : <div/>}
      >
        <button type='button' className={`btn btn-sm border-0 ${font}`} onClick={onSelectBlock}>{block.title}</button>
      </OverlayTrigger>
      { expanded && <ul className='ms-4'>{node.children.map(child =>
        <ChildItem node={child} key={child.id} />
      )}</ul> }
    </div>
  );
}

function ChildItem(props: { node: BlockTreeObject }) {
  const { node } = props;
  return (
    <li>
      {node.item.title || node.wbs ? <WBSTitle node={node} /> :
      <small className='text-secondary text-uppercase'>[{node.type}]</small>}
      <ul>
        {node.children.map((child, index) =>
          <ChildItem node={child} key={`node-${node.id}-child-${index}`} />
        )}
      </ul>
    </li>
  );
};


function WBSTitle(props: { node: BlockTreeObject }) {
  const { node } = props;
  return (
    <small className='d-flex gap-1' >
      <div className="fw-bold text-dark">{node.wbs}</div>
      { (node.wbs && node.item.title) &&
        <div className='text-dark'> - </div>
      }
      <div className="text-secondary">{node.item.title}</div>
    </small>
  );
}
